import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreateExcelFile = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 21,
	viewBox: "0 0 23 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0999 10L5.22217 8.5V19.5835C5.22217 20.0897 5.65073 20.5 6.1794 20.5H21.4983C22.0269 20.5 22.4555 20.0897 22.4555 19.5835V15.5L14.0999 10Z",
			fill: "#185C37"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0999 0.5H6.1794C5.65073 0.5 5.22217 0.910329 5.22217 1.4165V5.5L14.0999 10.5L18.7999 12L22.4555 10.5V5.5L14.0999 0.5Z",
			fill: "#21A366"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.22217 5.5H14.0999V10.5H5.22217V5.5Z",
			fill: "#107C41"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M11.576 4.5H5.22217V17H11.576C12.104 16.9984 12.5316 16.589 12.5333 16.0835V5.4165C12.5316 4.91101 12.104 4.50164 11.576 4.5Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M11.0538 5H5.22217V17.5H11.0538C11.5818 17.4984 12.0093 17.089 12.0111 16.5835V5.9165C12.0093 5.41101 11.5818 5.00164 11.0538 5Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M11.0538 5H5.22217V16.5H11.0538C11.5818 16.4984 12.0093 16.089 12.0111 15.5835V5.9165C12.0093 5.41101 11.5818 5.00164 11.0538 5Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .2,
			d: "M10.5316 5H5.22217V16.5H10.5316C11.0596 16.4984 11.4871 16.089 11.4888 15.5835V5.9165C11.4871 5.41101 11.0596 5.00164 10.5316 5Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.957231 5H10.5316C11.0603 5 11.4889 5.41033 11.4889 5.9165V15.0835C11.4889 15.5897 11.0603 16 10.5316 16H0.957231C0.428566 16 0 15.5897 0 15.0835V5.9165C0 5.41033 0.428566 5 0.957231 5Z",
			fill: "url(#paint0_linear_9361_1184)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.9646 13.478L4.97829 10.4905L3.13328 7.51953H4.61743L5.62428 9.41953C5.71724 9.60003 5.78094 9.73403 5.81541 9.82253H5.82847C5.89355 9.68066 5.96322 9.54076 6.03736 9.40302L7.11365 7.52054H8.47613L6.58411 10.474L8.52418 13.478H7.07449L5.9115 11.3925C5.85672 11.3038 5.81024 11.2106 5.7726 11.114H5.75537C5.7213 11.2086 5.67609 11.2992 5.62063 11.384L4.42317 13.478H2.9646Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.4984 0.5H14.1001V5.5H22.4557V1.4165C22.4557 0.910329 22.0271 0.5 21.4984 0.5Z",
			fill: "#33C481"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.1001 10.5H22.4557V15.5H14.1001V10.5Z",
			fill: "#107C41"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_9361_1184",
			x1: 1.99585,
			y1: 4.28387,
			x2: 9.01473,
			y2: 16.9805,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#18884F" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					stopColor: "#117E43"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#0B6631"
				})
			]
		}) })
	]
});
export default SvgCreateExcelFile;
